"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getId = exports.isBaseIdentifiable = void 0;
function isBaseIdentifiable(val) {
    return val.getIdentifier !== undefined;
}
exports.isBaseIdentifiable = isBaseIdentifiable;
function hasId(val) {
    return val.id !== undefined;
}
function getId(val) {
    if (isBaseIdentifiable(val)) {
        return val.getIdentifier();
    }
    if (hasId(val)) {
        return val.id;
    }
    return val;
}
exports.getId = getId;
//# sourceMappingURL=Identifiable.js.map